(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-search"]) return;
  try {
    
  class PremiumSearch extends HTMLElement {
    connectedCallback() {
      this.input=this.querySelector('input[name="q"]');
      this.panel=this.querySelector('.pa-search-suggestions');
      this.defaults=this.querySelector('[data-search-defaults]').innerHTML;
      this.status=this.querySelector('[data-search-status]');
      this.events=new AbortController();
      this.cache=new Map();
      this.requestId=0;
      this.index=-1;
      const signal=this.events.signal;
      this.input.addEventListener('focus',()=>this.focusSearch(),{signal});
      this.input.addEventListener('click',()=>{if(this.panel.hidden)this.focusSearch();},{signal});
      this.input.addEventListener('input',()=>this.queueSearch(),{signal});
      this.input.addEventListener('keydown',event=>this.navigate(event),{signal});
      this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget))this.closeSearch();},{signal});
      this.panel.addEventListener('keydown',event=>{if(event.key==='Escape'){this.closeSearch();this.input.focus();this.closeSearch();}},{signal});
      document.addEventListener('pointerdown',event=>{if(!event.composedPath().includes(this))this.closeSearch();},{signal});
      document.addEventListener('megaMenu:hover',()=>this.closeSearch(),{signal});
      window.addEventListener('resize',()=>this.positionPanel(),{signal});
      window.addEventListener('scroll',()=>this.positionPanel(),{signal,capture:true,passive:true});
      window.visualViewport?.addEventListener('resize',()=>this.positionPanel(),{signal});
      window.visualViewport?.addEventListener('scroll',()=>this.positionPanel(),{signal});
    }
    disconnectedCallback() {
      this.events?.abort();this.activeFetch?.abort();clearTimeout(this.timer);
    }
    focusSearch() {
      this.dismissed=false;
      const term=this.input.value.trim();
      if(!term){this.render(this.defaults);this.openSearch();}
      else this.fetchResults(term);
    }
    queueSearch() {
      clearTimeout(this.timer);this.activeFetch?.abort();this.requestId++;this.dismissed=false;
      this.index=-1;this.input.removeAttribute('aria-activedescendant');
      const term=this.input.value.trim();
      if(!term){this.render(this.defaults);this.status.textContent='';this.openSearch();return;}
      this.panel.replaceChildren();this.options=[];
      const message=document.createElement('p');message.className='pa-search-message';message.textContent=this.dataset.loading;this.panel.append(message);
      this.status.textContent=this.dataset.loading;this.openSearch();
      this.timer=setTimeout(()=>this.fetchResults(term),200);
    }
    async fetchResults(term) {
      const key=term.toLocaleLowerCase();
      if(this.cache.has(key)){this.render(this.cache.get(key));if(!this.dismissed)this.openSearch();return;}
      this.activeFetch?.abort();this.activeFetch=new AbortController();
      const sequence=++this.requestId;
      const url=new URL(this.dataset.endpoint,location.origin);
      url.searchParams.set('q',term);url.searchParams.set('section_id','premium-predictive-results');
      url.searchParams.set('resources[type]','query,product,collection');url.searchParams.set('resources[limit]','5');
      url.searchParams.set('resources[limit_scope]','each');url.searchParams.set('resources[options][unavailable_products]','last');
      this.panel.setAttribute('aria-busy','true');
      try {
        const response=await fetch(url,{signal:this.activeFetch.signal,headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error('Predictive search unavailable');
        const documentResult=new DOMParser().parseFromString(await response.text(),'text/html');
        const results=documentResult.querySelector('[data-premium-search-results]');
        if(!results)throw new Error('Search results unavailable');
        if(sequence!==this.requestId||term!==this.input.value.trim())return;
        this.cache.set(key,results.innerHTML);if(this.cache.size>20)this.cache.delete(this.cache.keys().next().value);
        this.render(results.innerHTML);
        if(!this.dismissed&&document.activeElement===this.input)this.openSearch();
      }catch(error){
        if(error.name==='AbortError'||sequence!==this.requestId)return;
        this.render(this.defaults);
        const message=document.createElement('p');message.className='pa-search-message';message.textContent=this.dataset.error;this.panel.prepend(message);
        this.status.textContent=this.dataset.error;
      }finally{if(sequence===this.requestId)this.panel.removeAttribute('aria-busy');}
    }
    render(markup) {
      this.panel.innerHTML=markup;this.index=-1;this.input.removeAttribute('aria-activedescendant');this.panel.removeAttribute('aria-busy');
      this.options=[...this.panel.querySelectorAll('[role="option"]')];
      this.options.forEach((option,index)=>{option.id=`${this.input.id}-option-${index}`;option.setAttribute('aria-selected','false');});
      this.status.textContent=this.dataset.count.replace('[count]',String(this.options.length));
    }
    positionPanel() {
      if(this.panel.hidden)return;
      const rect=this.getBoundingClientRect();const viewport=window.visualViewport;
      const viewportBottom=viewport?viewport.offsetTop+viewport.height:window.innerHeight;
      if(rect.bottom<0||rect.top>viewportBottom){this.closeSearch();return;}
      const width=Math.min(Math.max(rect.width,340),document.documentElement.clientWidth-24);
      const left=Math.max(12,Math.min(rect.left,document.documentElement.clientWidth-width-12));
      this.panel.style.left=`${left}px`;this.panel.style.top=`${rect.bottom+5}px`;this.panel.style.width=`${width}px`;
      this.panel.style.maxHeight=`${Math.max(100,Math.min(570,viewportBottom-rect.bottom-16))}px`;
    }
    openSearch() {
      this.panel.hidden=false;
      if(typeof this.panel.showPopover==='function'&&!this.panel.matches(':popover-open'))this.panel.showPopover();
      this.input.setAttribute('aria-expanded','true');this.positionPanel();
    }
    closeSearch() {
      this.dismissed=true;
      if(typeof this.panel.hidePopover==='function'&&this.panel.matches(':popover-open'))this.panel.hidePopover();
      this.panel.hidden=true;this.input.setAttribute('aria-expanded','false');this.input.removeAttribute('aria-activedescendant');
      this.options?.forEach(option=>option.setAttribute('aria-selected','false'));this.index=-1;
    }
    navigate(event) {
      if(event.key==='Escape'){if(!this.panel.hidden){event.preventDefault();event.stopPropagation();this.closeSearch();}return;}
      if(!['ArrowDown','ArrowUp','Enter'].includes(event.key))return;
      if(event.key==='Enter'){
        if(!this.panel.hidden&&this.index>=0){event.preventDefault();this.options[this.index]?.click();}
        return;
      }
      event.preventDefault();if(this.panel.hidden){this.dismissed=false;this.openSearch();}
      if(!this.options?.length)return;
      this.index=event.key==='ArrowDown'?(this.index+1)%this.options.length:(this.index<=0?this.options.length:this.index)-1;
      this.options.forEach((option,index)=>option.setAttribute('aria-selected',String(index===this.index)));
      const option=this.options[this.index];this.input.setAttribute('aria-activedescendant',option.id);option.scrollIntoView({block:'nearest'});
    }
  }
  if(!customElements.get('premium-search'))customElements.define('premium-search',PremiumSearch);

  } catch(e) { console.error(e); }
})();
})();
